import apiClient from "../utils/Http";

// ==================== LIST / BROWSE ====================
export const getAllCourses = (params = {}) =>
  apiClient.get('/api/course/', { params });

export const getAllCoursesCardView = () =>
  apiClient.get('/api/courses/card-view/');

export const getAllPublishedCardView = (params = {}) =>
  apiClient.get('/api/courses/card-view/', {
    params: { status: 'published', ...params },
  });

export const getMyCoursesAsInstructor = () =>
  apiClient.get('/api/courses/my-courses/');

export const getFeaturedCourses = () =>
  apiClient.get('/api/course/', { params: { is_featured: true } });

export const searchCourses = (query) =>
  apiClient.get('/api/course/', { params: { search: query } });

export const getAllProjects = (params = {}) =>
  apiClient.get('/api/course/', { params });

// ==================== PUBLIC COURSE DETAIL (slug) ====================
export const getCourseBySlug = (slug) =>
  apiClient.get(`/api/course/${slug}/`);

export const getCoursePreviewStructure = (slug) =>
  apiClient.get(`/api/courses/${slug}/preview/`);

export const getCourseFullStructure = (slug) =>
  apiClient.get(`/api/courses/${slug}/full-structure/`);

export const getPreviewLessonsByCourse = (slug) => {
  return apiClient.get(`/api/courses/${slug}/preview-lessons/`);
};

// ==================== COURSES BY CATEGORY (slug) ====================
export const getCoursesByCategory = (categorySlug) =>
  apiClient.get(`/api/courses/by-category/${categorySlug}/`);

// ==================== DASHBOARD CRUD (still pk — instructor owns them) ====================
export const createCourse = (data) =>
  apiClient.post('/api/course/', data);

export const updateCourse = (id, data) =>
  apiClient.patch(`/api/course/${id}/`, data);

export const deleteCourse = (id) =>
  apiClient.delete(`/api/course/${id}/`);